import { out } from "@app/controller";

type NormalizedUrl = "/" | `/${string}`;

export function installRouter() {
  document.addEventListener("click", (evt: MouseEvent) => {
    const target = evt.target as Element | null;
    const anchor = target?.closest<HTMLAnchorElement>("a") ?? null;
    if (!anchor) return;
    const href = anchor.getAttribute("href");
    if (
      !href ||
      href.startsWith("http") ||
      href.startsWith("mailto:") ||
      href.startsWith("#")
    )
      return;
    const normalized = (
      href !== "/" ? href.replace(/\/$/, "") : "/"
    ) as NormalizedUrl;
    evt.preventDefault();
    if (location.pathname === normalized) return;
    out(normalized, anchor);
  });

  window.addEventListener("popstate", () => {
    out(location.pathname as NormalizedUrl, "back");
  });
}
